module.exports = __webpack_public_path__ + "static/media/providerGoldTop3D.27129f23.webp";